import React from "react";
import { reportClientError } from "../services/frontendMonitoring";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError({
      message: error?.message || "React render error",
      stack: error?.stack,
      metadata: { componentStack: info?.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="auth-shell">
          <div className="auth-card surface-card">
            <div className="auth-brand">
              <div className="auth-brand-badge">PennyPantry</div>
              <h1>Something went wrong</h1>
              <p>We received an error report. Please reopen the app and try again.</p>
            </div>
            <button className="primary-action" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
